import type { FaireProductEntity } from "../../entity_types/product";

export const p_8d4fmqshpx: FaireProductEntity = {
  token: "p_8d4fmqshpx",
  type: "product",
  name: "Nectar and Petals Shampoo hotel collection",
  brandToken: "b_9ysabjm1c7",
  brandName: "Lux Leonis",
  imageUrl:
    "https://cdn.faire.com/fastly/a26ab7fbe5db078f0dab1a14ae0d25bb5b604cc6f60291f7020d66e2bb6bc617.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.5,
  description:
    "This is a custom product that I designed for a historic boutique hotel in Georgia. I am now making this product available to your customers. \nMade with gentle, sulfate free ingredients, conditioners and hair loving proteins.\n8 oz bottles with pumps..",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:44.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
